import { bl_wf_md_process_transition_to_transition_trigger_RowClass, bl_wf_md_process_transition_to_transition_trigger_RowInterface } from "../../../dbschema";
import {BaseContainerModel} from "../../base-container.model";

export class WfMdTransitionToTransitionTriggerContainerModel extends BaseContainerModel{
  bl_wf_md_process_transition_to_transition_trigger: bl_wf_md_process_transition_to_transition_trigger_RowInterface = new bl_wf_md_process_transition_to_transition_trigger_RowClass();
}
